/**
 * 文章資料集中管理 - 統一數據源
 * ✅ 更新 modifiedDate 至 2026 年 3 月
 * ✅ 所有 Schema 日期與內容保持一致
 */
const articleData = [
  {
    id: 1,
    title: "初學者的 Omakase 完整指南：從零開始的品味之旅",
    excerpt: "第一次體驗 Omakase？從預約到用餐，這篇文章將帶您了解所有需要知道的事情，包括禮儀、價格範圍和如何選擇合適的餐廳。",
    author: "料理文化研究室",
    readTime: "15 分鐘",
    category: "入門指南",
    image: "https://images.unsplash.com/photo-1611143669185-af224c5e3252?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    views: "18.3K",
    likes: "1.2K",
    tags: ["初學者", "禮儀", "預約", "價格指南"],
    slug: "beginners-complete-guide-to-omakase",
    metaTitle: "初學者的 Omakase 完整指南：從零開始的品味之旅 | 料理文化",
    metaDescription: "第一次體驗日本料理的 Omakase？從預約到用餐禮儀，這篇完整指南將帶您了解所有初次體驗需要知道的事情，讓您自信享受這場美食文化之旅。",
    metaKeywords: "Omakase,初學者指南,日本料理,壽司,預約技巧,用餐禮儀,價格範圍,餐廳選擇",
    publishDate: "2025-09-15T10:00:00+08:00",
    modifiedDate: "2026-03-07T10:00:00+08:00"
  },
  {
    id: 2,
    title: "春季 Omakase：櫻花季的味覺饗宴與文化意涵",
    excerpt: "春天是日本料理最美的季節之一。深入了解春季 Omakase 的特色食材，從櫻鯛到竹筍，每一道菜都述說著春天的故事。",
    author: "季節料理專家",
    readTime: "18 分鐘",
    category: "美食體驗",
    image: "https://images.unsplash.com/photo-1553621042-f6e147245754?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    views: "11.4K",
    likes: "923",
    tags: ["春季", "櫻鯛", "竹筍", "季節食材", "日本文化"],
    slug: "spring-omakase-sakura-season",
    metaTitle: "春季 Omakase：櫻花季的味覺饗宴與文化意涵 | 季節料理",
    metaDescription: "探索春季 Omakase 的獨特魅力，從櫻鯛到竹筍，了解日本料理如何透過季節食材展現春天的生機與美學，體驗一場視覺與味覺的春季盛宴。",
    metaKeywords: "春季Omakase,櫻花季,櫻鯛,竹筍,櫻花蝦,蠶豆,春季料理,日本季節美學",
    publishDate: "2025-09-28T10:00:00+08:00",
    modifiedDate: "2026-03-07T10:00:00+08:00"
  },
  {
    id: 3,
    title: "壽司 Omakase vs 懷石 Omakase：兩種截然不同的文化體驗",
    excerpt: "壽司 Omakase 和懷石 Omakase 各有其獨特魅力。深入了解兩者的差異，選擇最適合您的用餐體驗。",
    author: "日本料理評論家",
    readTime: "25 分鐘",
    category: "文化深度",
    image: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    views: "21.7K",
    likes: "1.6K",
    tags: ["壽司", "懷石", "比較", "選擇指南", "文化差異"],
    slug: "sushi-vs-kaiseki-omakase-comparison",
    metaTitle: "壽司 Omakase vs 懷石 Omakase：兩種截然不同的文化體驗 | 深度比較",
    metaDescription: "壽司Omakase與懷石Omakase各代表日本料理文化的不同面向。本文深入比較兩者在起源、特色、用餐體驗等方面的差異，幫助您選擇最適合的體驗。",
    metaKeywords: "壽司Omakase,懷石Omakase,日本料理比較,江戶前壽司,茶道文化,料理藝術,選擇指南",
    publishDate: "2025-10-10T10:00:00+08:00",
    modifiedDate: "2026-03-07T10:00:00+08:00"
  },
  {
    id: 4,
    title: "台灣 Omakase 文化發展：在地化的創新與傳承",
    excerpt: "台灣的 Omakase 文化如何在保持日本傳統的同時，融入在地特色？探索台灣日本料理的獨特發展軌跡。",
    author: "台灣料理文化研究者",
    readTime: "20 分鐘",
    category: "文化深度",
    image: "https://images.unsplash.com/photo-1574484284002-952d92456975?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    views: "9.8K",
    likes: "712",
    tags: ["台灣", "在地化", "創新", "文化發展"],
    slug: "taiwan-omakase-culture-development",
    metaTitle: "台灣 Omakase 文化發展：在地化的創新與傳承 | 文化研究",
    metaDescription: "探索台灣Omakase文化的獨特發展軌跡，從日治時期的基礎到現代的創新融合，了解台灣如何在保持日本料理傳統精神的同時，注入在地食材與文化特色。",
    metaKeywords: "台灣Omakase,日本料理在地化,東港黑鮪魚,台灣和牛,創新料理技法,文化融合,台式日本料理",
    publishDate: "2025-10-25T10:00:00+08:00",
    modifiedDate: "2026-03-07T10:00:00+08:00"
  },
  {
    id: 5,
    title: "頂級食材解析：從築地到餐桌的品質之旅",
    excerpt: "深入了解 Omakase 中使用的頂級食材，從產地選擇到處理技巧，每個環節都影響著最終的味覺體驗。",
    author: "食材專家",
    readTime: "22 分鐘",
    category: "美食體驗",
    image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    views: "13.2K",
    likes: "978",
    tags: ["食材", "築地", "品質", "處理技巧"],
    slug: "premium-ingredients-analysis-from-tsukiji",
    metaTitle: "頂級食材解析：從築地到餐桌的品質之旅 | 食材專論",
    metaDescription: "深入探索Omakase頂級食材的完整旅程，從築地市場的競標系統到精細的食材處理技術，了解每個環節如何影響最終呈現在餐桌上的美味體驗。",
    metaKeywords: "Omakase食材,築地市場,藍鰭鮪魚,海膽,食材分級,熟成技術,乾式熟成,昆布締",
    publishDate: "2025-11-12T10:00:00+08:00",
    modifiedDate: "2026-03-07T10:00:00+08:00"
  },
  {
    id: 6,
    title: "Omakase 禮儀大全：從預約到離席的完整指南",
    excerpt: "掌握正確的 Omakase 禮儀，不僅能獲得更好的用餐體驗，更能展現對日本料理文化的尊重與理解。",
    author: "禮儀專家",
    readTime: "16 分鐘",
    category: "用餐禮儀",
    image: "https://images.unsplash.com/photo-1551218808-94e220e084d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    views: "15.8K",
    likes: "1.1K",
    tags: ["禮儀", "文化", "尊重", "指南"],
    slug: "complete-omakase-etiquette-guide",
    metaTitle: "Omakase 禮儀大全：從預約到離席的完整指南 | 文化禮儀",
    metaDescription: "全面掌握Omakase用餐禮儀，從預約、著裝、入席到用餐、互動、離席的每個細節，讓您展現對日本料理文化的尊重，同時獲得最佳用餐體驗。",
    metaKeywords: "Omakase禮儀,日本料理文化,預約技巧,用餐禮節,筷子使用,廚師互動,拍照禮儀,結帳禮儀",
    publishDate: "2025-11-28T10:00:00+08:00",
    modifiedDate: "2026-03-07T10:00:00+08:00"
  }
];

export default articleData;